_ = require 'underscore'

{
  GOLD_RECOMMENDATION
  GOLD_UPGRADE
} = require 'data/gold-banners'

getNonZeroCredits = (member) ->
  _.filter member.get('credits'), (c) ->
    !c.applied && c.count > 0 && c.type in ['invitation', 'promoCode']

module.exports = (member) ->
  if member.isInAnyBCOrganization() then return null

  hasGold = member.isGold()

  if hasGold && !member.isDismissed(GOLD_UPGRADE)
    return {
      type: GOLD_UPGRADE
    }

  if member.isDismissed(GOLD_RECOMMENDATION) then return null

  credits = getNonZeroCredits(member)

  numCreditMonths = _.reduce(credits, ((memo, credit) -> memo + credit.count), 0)

  if !numCreditMonths then return null

  if numCreditMonths > 12
    numCreditMonths = 12

  invitedMemberNames = _.chain(credits)
    .filter((c) -> c.type == 'invitation' && c.memberInvited?)
    .pluck('memberInvited')
    .pluck('fullName')
    .value()

  {
    invitedMemberNames
    numCreditMonths
    type: GOLD_RECOMMENDATION
  }



// WEBPACK FOOTER //
// ./app/scripts/lib/util/get-gold-banner.coffee